module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activityInfo) ? _c('div', {
    staticClass: "content-main"
  }, [_c('div', {
    staticClass: "top-bar com-model m-b-15"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/index/jobfair'
      }
    }
  }, [_vm._v("招聘会")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("招聘会详情")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "com-model m-b-15",
    staticStyle: {
      "padding": "24px"
    }
  }, [_c('activity-item', {
    attrs: {
      "item": _vm.activityInfo,
      "itemType": "detail"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "com-model m-b-15",
    staticStyle: {
      "padding": "0 24px"
    }
  }, [_c('div', {
    staticClass: "title m-b-20"
  }, [_vm._v("招聘会简介")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "desc-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.activityInfo.descImage
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "desc-text"
  }, [_vm._v("\n            " + _vm._s(_vm.activityInfo.description) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "com-model",
    staticStyle: {
      "padding": "0 24px 37px"
    }
  }, [_c('div', {
    staticClass: "title m-b-20"
  }, [_vm._v("报名企业"), _c('span', [_vm._v("（" + _vm._s(_vm.activityInfo.companyInfoList.length) + "）")])]), _vm._v(" "), _c('div', {
    staticClass: "company-list flex"
  }, [_vm._l((_vm.activityInfo.companyInfoList), function(item, index) {
    return [(index < 4) ? _c('div', {
      key: index,
      staticClass: "company-item flex flex-between flex-column"
    }, [_c('div', {
      staticClass: "company-img"
    }, [_c('img', {
      attrs: {
        "src": item.companyLogo
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "company-name"
    }, [_vm._v(_vm._s(item.companyName))])]) : _vm._e()]
  }), _vm._v(" "), (_vm.activityInfo.companyInfoList.length > 4) ? _c('div', {
    staticClass: "company-more flex flex-center"
  }, _vm._l((3), function(item) {
    return _c('div', {
      key: item,
      staticClass: "dian"
    })
  })) : _vm._e()], 2)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42e023fa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/jobfairinfo.vue
// module id = 872
// module chunks = 1